<tam-dialog class="save-content-body" tid="save_screen_dialog" [opened]="isOpen" [dialogWidth]="500"
    (keydown.esc)="onCancelClick()">
    <ng-template #title>
        <div class="title-box">
            <span>{{pageTitle}}</span>
        </div>
        <div class="close-button-box">
            <smart-icon class="dark small" name="close" (click)="onCancelClick()"></smart-icon>
        </div>
    </ng-template>

    <form [formGroup]="screenForm">
        <ng-template #body>
            <div class="tam-form-field" [ngClass]="{'has-error': name.invalid}">
                <div class="tam-form-label">
                    <span>Name&nbsp;<span class="required-field">*</span></span>
                </div>
                <input type="text" class="tam-textbox" formControlName="name">
                <div class="tam-form-help" *ngIf="name.invalid && name.errors['required']">Please enter information
                    for
                    required field.</div>
                <div class="tam-form-help" *ngIf="name.invalid && name.errors['maxlength']">{{pageType}} name exceeds
                    the
                    maximum of 128 characters allowed.</div>
                <div class="tam-form-help" *ngIf="name.invalid && name.errors['duplicated']">{{pageType}} name has
                    already
                    existed. Please change to other name.</div>
            </div>
            <div class="tam-form-field" [ngClass]="{'has-error': description.invalid}">
                <div class="tam-form-label">
                    <span>Description</span>
                </div>
                <textarea class="tam-textbox" formControlName="description"></textarea>
                <div class="tam-form-help" *ngIf="description.invalid && description.errors['maxlength']">{{pageType}}
                    description exceeds the maximum of 256 characters allowed.</div>
            </div>
            <div class="switch-box">
                <div>
                    <span>Public</span>
                </div>
                <kendo-switch onLabel="Yes" offLabel="No" formControlName="isPublic">
                </kendo-switch>
            </div>
            <div class="list-box"
                [style.display]="!currentUser.credential.publishPubConfiguration || isPublic.value ? 'none' : 'block'">
                <tam-dual-list #dualList [config]="dualListConfig" [itemRender]="accessListItem">
                    <ng-template #accessListItem let-item>
                        <div class="access-item">
                            <span
                                [style.font-weight]="item.data.type === 'Team' ? 'bold' : 'normal'">{{item.data.name}}</span>
                        </div>
                    </ng-template>
                </tam-dual-list>
            </div>
            <div class="tam-form-field default-layout" *ngIf="showDefaultLayout">
                <label tam-checkbox formControlName="defaultHomeLayout">
                    <span class="tam-form-label">Set layout as default home screen for recipients</span>
                </label>
            </div>
        </ng-template>
    </form>

    <ng-template #footer>
        <button class="footer-button footer-research-button" tam-button [tamType]="'tertiary'" [tamSize]="'normal'"
            (click)="onCancelClick()">Cancel</button>
        <button class="footer-button footer-research-button" tam-button [tamType]="'primary'" [tamSize]="'normal'"
            [tamLoading]="isSaving" [disabled]="saveBtnStatus" (click)="onSaveClick()">Save</button>
    </ng-template>

</tam-dialog>